export default __webpack_public_path__ + "static/media/padlockGrey.f522735f.svg";